<template>
    <v-card>
        <v-card-title>請勾選您想匯出的欄位
            <v-spacer></v-spacer>
                <v-btn small color="red lighten-2" @click="saveSetting">
                    <div v-show="!exportLoading">確認匯出</div>
                    <div v-show="exportLoading">
                        <v-progress-circular size="25" indeterminate></v-progress-circular>
                    </div>
                </v-btn>
            </v-card-title>
        <v-list style="max-height: 400px" class="overflow-y-auto">
            <div v-for="(field, index) in selectedColumns" :key="index">
                <v-list-item :class="[{'blue lighten-5': field.selected }, 'white']">
                    <v-list-item-action>
                        <v-checkbox v-model="field.selected"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>{{field.text}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                 <v-divider v-if="index + 1 < selectedColumns.length"></v-divider> 
            </div>
        </v-list>
    </v-card>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
export default {
    props:{
        exportLoading: Boolean
    },
    data(){
        return {
            selectedColumns:[],
        }
    },
    computed:{
        ...mapGetters('holderexport',[
            'getSelectHolderExportColumns',
            'getAllHolderExportColumns',
        ]),
        getSelectedColumnList(){
            return this.selectedColumns.filter(field => {
                                        if (field.selected === true) {
                                        return field
                                        }
                                    });
        }
    },
    methods:{
        ...mapMutations('holderexport',[
            'setSelectedHolderExportColumns'
        ]),
        saveSetting(){
            this.exportLoading = true
            this.setSelectedHolderExportColumns(this.getSelectedColumnList)
            //父元件須要去指定@ChangeDialogShowSettingEvent所設定的方法，該方法必須要指定參數。
            //此事件用來觸發Dialog關閉
            this.$emit('ChangeDialogShowSettingEvent', false)
        },
    },
    created(){
        this.selectedColumns = this.getAllHolderExportColumns
    }
}
</script>
